<div class="ktbl-bottom-zeile">
  <div class="ktbl-bottom-zeile-inner">
  <span class="ktbl-bottom-zeile-typografie">
    <a class="ktbl-typografie-reg-14" href="https://ktbl.de" target="_blank"
      >KTBL-Startseite
    </a>

    <a
      class="ktbl-typografie-reg-14"
      href="https://ktbl.de/service/kontakt/"
      target="_blank"
      >Kontakt
    </a>
    <a
      class="ktbl-typografie-reg-14"
      href="https://www.ktbl.de/service/impressum/"
      target="_blank"
      >Impressum
    </a>

    <a
      class="ktbl-typografie-reg-14"
      href="https://www.ktbl.de/service/nutzungsbedingungen-fuer-online-anwendungen"
      target="_blank"
      >Nutzungsbedingungen
    </a>

    <a
      class="ktbl-typografie-reg-14"
      href="https://www.ktbl.de/service/datenschutz"
      target="_blank"
      >Datenschutzerklärung
    </a>
  </span>
</div>
</div>

 